import { render, staticRenderFns } from "./HomeSimBox.vue?vue&type=template&id=07c04bdf&scoped=true&"
import script from "./HomeSimBox.vue?vue&type=script&lang=js&"
export * from "./HomeSimBox.vue?vue&type=script&lang=js&"
import style0 from "./HomeSimBox.vue?vue&type=style&index=0&id=07c04bdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c04bdf",
  null
  
)

export default component.exports